module.exports = __webpack_public_path__ + "img/FLECHE_BOUTON_ABS_PRES_GRILLE_POINTAGE_DESACTIVE.d0c5dd55.svg";